import React, { type SVGProps } from "react";
import { iconSizes, type IconProps } from "./utils/shared";
const FlashlightSlashFill = (props: SVGProps<SVGSVGElement> & IconProps) => (
  <svg
    width={props.size ? iconSizes[props.size] : iconSizes["s"]}
    height={props.size ? iconSizes[props.size] : iconSizes["s"]}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    title="FlashlightSlashFill"
    {...props}
  >
    <path d="M13 10H20L11 23V14H4L13 1V10Z" />
    <mask
      id="path-2-outside-1_1_2"
      maskUnits="userSpaceOnUse"
      x={2.11359}
      y={2.39507}
      width={20.3174}
      height={19.2525}
    >
      <rect fill="white" x={2.11359} y={2.39507} width={20.3174} height={19.2525} />
      <path d="M4.83353 2.39507L21.7824 18.1132L20.2966 19.7154L3.34771 3.99723L4.83353 2.39507Z" />
    </mask>
    <path d="M4.83353 2.39507L21.7824 18.1132L20.2966 19.7154L3.34771 3.99723L4.83353 2.39507Z" />
    <path
      d="M21.3166 18.6155L4.36768 2.89739L2.32773 5.09707L19.2766 20.8152L21.3166 18.6155Z"
      fill="white"
      mask="url(#path-2-outside-1_1_2)"
    />
  </svg>
);
export default React.memo(FlashlightSlashFill);
